import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { ILabel } from '../../../../utils/types/contentful';
import clsx from 'clsx';

interface DividerProps {
  label?: ILabel;
  color?: string;
  margin?: string;
}

export const Divider = ({ label, color, margin }: DividerProps) => (
  <div
    className={clsx('relative', {
      [margin]: margin,
    })}>
    <div
      className='absolute inset-0 flex items-center'
      aria-hidden='true'>
      <div
        className={clsx('w-full border-t', {
          [`border-${color}`]: color,
        })}
      />
    </div>
    {label && (
      <div className='relative flex justify-start'>
        <div className='pr-2 bg-white'>
          <Label
            {...label}
            size='md'
          />
        </div>
      </div>
    )}
  </div>
);
